<header class="app-header">
  <div class="header-content">
    <!-- Logo/Title -->
    <div class="header-logo">
      <a [routerLink]="['/dashboard']" (click)="closeMenu()">
        <div class="app-title">
          <img [src]="logoSrc" alt="SBF Logo" class="header-logo-img" />
          <span class="header-title-wrapper">
            <span class="header-title-text">{{ vereinsName || 'einfachnurlernen.de' }}</span>
            <span *ngIf="(networkStatus$ | async)?.isOnline === false" class="offline-icon" title="Offline" style="margin-left:8px;display:inline-flex;vertical-align:middle;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 1L23 23" stroke="red" stroke-width="2"/>
                <path d="M2.88 7.88a10.94 10.94 0 0 1 16.24 0" stroke="red"/>
                <path d="M5.7 10.7a7.07 7.07 0 0 1 10.6 0" stroke="red"/>
                <path d="M8.53 13.53a3.13 3.13 0 0 1 4.94 0" stroke="red"/>
                <circle cx="12" cy="18" r="1" fill="red"/>
              </svg>
            </span>
          </span>
        </div>
      </a>
    </div>


    <!-- User Actions Desktop -->
    <div class="desktop-actions">
      <ng-container *ngIf="user; else unauthActions">
        <ng-container *ngIf="shouldShowTrialCountdown(); else userNameOrPruefung">
          <span class="pruefung-countdown trial-countdown" [title]="getTrialTooltip()" (click)="navigateTo('/license-request')">
            Noch {{ getTrialDaysLeft() }} Tag{{ getTrialDaysLeft() !== 1 ? 'e' : '' }} Testzeit
          </span>
        </ng-container>
        <ng-template #userNameOrPruefung>
          <ng-container *ngIf="licenseStatusLoaded && pruefung; else userNameOnly">
            <span class="pruefung-countdown" (click)="openPruefungModal()" title="Klicken fuer Details">
              Noch {{ pruefung.tage_bis_pruefung }} Tag{{ pruefung.tage_bis_pruefung !== 1 ? 'e' : '' }} bis zur Pruefung
            </span>
          </ng-container>
          <ng-template #userNameOnly>
            <span class="user-name">{{ user?.vorname }}</span>
          </ng-template>
        </ng-template>

        <a *ngIf="isVereinAdmin()" [routerLink]="['/verein-dashboard']" class="btn-admin">Vereinsverwaltung</a>
        <a *ngIf="isAdmin()" [routerLink]="['/admin']" class="btn-admin">Admin</a>
        <a [routerLink]="['/profile']" class="btn-secondary">Profil</a>
        <button (click)="logout()" class="btn-logout">Abmelden</button>
      </ng-container>

      <ng-template #unauthActions>
        <a [routerLink]="['/login']" class="btn-secondary">Anmelden</a>
        <a [routerLink]="['/register']" class="btn-primary">Registrieren</a>
      </ng-template>
    </div>

    <!-- Mobile Hamburger Button -->
    <button class="hamburger-btn" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen()">
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </button>
  </div>

  <!-- Mobile Menu (Sidebar) -->
  @if (isMenuOpen()) {
    <div class="mobile-menu-overlay" (click)="closeMenu()"></div>
    <nav class="mobile-menu">
      <div class="mobile-menu-header">
        <h2>Menü</h2>
        <button class="close-btn" (click)="closeMenu()">✕</button>
      </div>

      <div class="mobile-menu-content">
        <!-- Main Navigation -->
        <div class="menu-section">
          <a [routerLink]="['/dashboard']" (click)="closeMenu()" class="menu-item">
            <span class="menu-icon">🏠</span> Dashboard
          </a>
          <a [routerLink]="['/learning/license']" (click)="closeMenu()" class="menu-item">
            <span class="menu-icon"><img src="assets/fernrohr.svg" alt="Lernen" /></span> Lernen
          </a>
          <a [routerLink]="['/exam/license']" (click)="closeMenu()" class="menu-item">
            <span class="menu-icon"><img src="assets/signalflagge.svg" alt="Prüfung" /></span> Prüfung
          </a>
          <a [routerLink]="['/lernstoff']" (click)="closeMenu()" class="menu-item">
            <span class="menu-icon"><img src="assets/boje.svg" alt="Offizieller Fragenkatalog" /></span> Offizieller Fragenkatalog
          </a>
          <a [routerLink]="['/calendar']" (click)="closeMenu()" class="menu-item">
            <span class="menu-icon"><img src="assets/calendar.svg" alt="Kalender" /></span> Kalender
          </a>
          <a [routerLink]="['/guide']" (click)="closeMenu()" class="menu-item">
            <span class="menu-icon" aria-hidden="true">
              <svg viewBox="-16 -16 32 32" width="20" height="20" role="img" focusable="false">
                <circle cx="0" cy="0" r="16" fill="none" stroke="#3B82F6" stroke-width="2"></circle>
                <circle cx="0" cy="-6" r="2" fill="#3B82F6"></circle>
                <rect x="-1.5" y="-2" width="3" height="10" fill="#3B82F6" rx="1.5"></rect>
              </svg>
            </span>
            Anleitungen
          </a>
        </div>

        <!-- User Menu -->
        @if (user) {
          <div class="menu-section">
            <div class="menu-item menu-user-info">
              <span class="menu-icon">👤</span>
              <div class="user-info">
                <p class="user-name-mobile">{{ user.vorname }} {{ user.nachname }}</p>
                <p class="user-email">{{ user.email }}</p>
              </div>
            </div>
          </div>

          <div class="menu-section">
            <a [routerLink]="['/statistics']" (click)="closeMenu()" class="menu-item">
              <span class="menu-icon">📊</span> Statistiken
            </a>
            <a [routerLink]="['/profile']" (click)="closeMenu()" class="menu-item">
              <span class="menu-icon"><img src="assets/steuerrad.svg" alt="Profil" /></span> Profil
            </a>
            @if (isVereinAdmin()) {
              <a [routerLink]="['/verein-dashboard']" (click)="closeMenu()" class="menu-item">
                <span class="menu-icon">👥</span> Vereinsverwaltung
              </a>
            }
            @if (isAdmin()) {
              <a [routerLink]="['/admin']" (click)="closeMenu()" class="menu-item">
                <span class="menu-icon">🔑</span> Admin-Panel
              </a>
            }
          </div>
        }

        <!-- Footer Links -->
        <div class="menu-section menu-footer-links">
          <a [routerLink]="['/ueber-mich']" (click)="closeMenu()" class="menu-item small">
            Über mich
          </a>
          <a [routerLink]="['/impressum']" (click)="closeMenu()" class="menu-item small">
            Impressum
          </a>
          <a [routerLink]="['/datenschutz']" (click)="closeMenu()" class="menu-item small">
            Datenschutz
          </a>
          <a [routerLink]="['/agb']" (click)="closeMenu()" class="menu-item small">
            AGB
          </a>
          <a [routerLink]="['/quellangaben']" (click)="closeMenu()" class="menu-item small">
            Quellangaben
          </a>
        </div>
      </div>

      <!-- Mobile Menu Footer -->
      <div class="mobile-menu-footer">
        @if (user) {
          <button (click)="logout()" class="btn-logout-mobile">Abmelden</button>
        } @else {
          <a [routerLink]="['/login']" (click)="closeMenu()" class="btn-login-mobile">
            Anmelden
          </a>
          <a [routerLink]="['/register']" (click)="closeMenu()" class="btn-register-mobile">
            Registrieren
          </a>
        }
      </div>
    </nav>
  }
</header>

<!-- Prüfungs-Details Modal -->
@if (showPruefungModal && pruefung) {
  <div class="modal-overlay" (click)="closePruefungModal()">
    <div class="modal-content pruefung-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>📋 Deine Prüfung</h3>
        <button class="close-button" (click)="closePruefungModal()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="pruefung-detail">
          <div class="detail-icon">&#127919;</div>
          <div class="detail-content">
            <h4>Countdown</h4>
            <p class="countdown-big">{{ pruefung.tage_bis_pruefung }} Tag{{ pruefung.tage_bis_pruefung !== 1 ? 'e' : '' }}</p>
          </div>
        </div>

        <div class="pruefung-detail">
          <div class="detail-icon">📅</div>
          <div class="detail-content">
            <h4>Datum & Uhrzeit</h4>
            @if (pruefung.pruefung_datum) {
              <p>{{ pruefung.pruefung_datum | date:'dd.MM.yyyy' }}</p>
              <p class="time">{{ pruefung.pruefung_datum | date:'HH:mm' }} Uhr</p>
            } @else {
              <p>Noch kein Datum festgelegt</p>
            }
          </div>
        </div>

        <div class="pruefung-detail pruefung-ort-highlight">
          <div class="detail-icon">📍</div>
          <div class="detail-content">
            <h4>Prüfungsort</h4>
            @if (pruefung.pruefung_ort_strasse || pruefung.pruefung_ort_plz || pruefung.pruefung_ort_stadt) {
              @if (pruefung.pruefung_ort_strasse) {
                <p>{{ pruefung.pruefung_ort_strasse }}</p>
              }
              @if (pruefung.pruefung_ort_plz || pruefung.pruefung_ort_stadt) {
                <p>{{ pruefung.pruefung_ort_plz }} {{ pruefung.pruefung_ort_stadt }}</p>
              }
              <a [href]="getGoogleMapsUrl()" target="_blank" class="btn-maps">
                🗺️ In Google Maps öffnen
              </a>
            } @else {
              <p>Noch kein Ort festgelegt</p>
            }
          </div>
        </div>

        <div class="pruefung-kurs-info">
          <p class="kurs-info-text">📚 Kurs: {{ pruefung.kurs_name }}</p>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn-primary" (click)="closePruefungModal()">Schließen</button>
      </div>
    </div>
  </div>
}
